import { render } from "./columnChart2.vue?vue&type=template&id=11381120"
import script from "./columnChart2.vue?vue&type=script&lang=js"
export * from "./columnChart2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__